/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { formatCurrency } from '../../Functions';
import { medicalTeamDetail } from "../../Api";

const QueryDetail = (props) => {
  
  const { NumeroRol, Numero_PAM, Paciente, Fecha_Ingreso, Fecha_Alta, Nombre } = props;
  const [state, setState] = useState({
    data: [],
    loading: true
  });

  const _medicalTeamDetail = async () => {
    
    const _response = await medicalTeamDetail({
      rol:NumeroRol,
      pam:Numero_PAM,
    });
    if (_response.status) {
      setState({
        data: _response.data.records,
        loading: false,
      });
    }
  }

  useEffect(() => {
    _medicalTeamDetail();
  }, [props])

  return (
      <>
        {!state.loading && (
          <>
          <div className="table-responsive">
            <table className="table table-bordered table-payment-detailtype">
              <thead className="text-white">
                <tr>
                  <th>N° ROL</th>
                  <th>Nombre Paciente</th>
                  <th>Fecha Hospitalización</th>
                  <th>Fecha Alta Médica</th>
                  <th>Previsión</th>
                  <th>N° PAM</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{NumeroRol}</td>
                  <td>{Paciente}</td>
                  <td>{Fecha_Ingreso}</td>
                  <td>{Fecha_Alta}</td>
                  <td>{Nombre}</td>
                  <td>{Numero_PAM}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-payment-detailtype">
              <thead className="text-white">
              <tr>
                <th colSpan={4}></th>
                <th colSpan={3} className="text-center">BONO / SEGURO</th>
                <th colSpan={3} className="text-center">COPAGO</th>
              </tr>
              <tr>
                <th>Profesional</th>
                <th>Código Prestación</th>
                <th>Acción</th>
                <th>Monto Prestación</th>
                <th>Monto</th>
                <th>Fecha Proceso</th>
                <th>Fecha Pago</th>
                <th>Monto</th>
                <th>Fecha Proceso</th>
                <th>Fecha Pago</th>
              </tr>
              </thead>
              <tbody>
              {state.data.length > 0 && state.data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.Profesional}</td>
                    <td>{item.Prestacion_Codigo_Prestacion}</td>
                    <td>{item.Accion_Intervencion}</td>
                    <td>{formatCurrency(item.Monto_Prestacion)}</td>
                    <td>{formatCurrency(item.Monto_Bonificado)}</td>
                    <td>{item.FecProcBono || '-'}</td>
                    <td>{item.FechaPago_Bono || '-'}</td>
                    <td>{formatCurrency(item.Monto_Copago)}</td>
                    <td>{item.FecProcCopago || '-'}</td>
                    <td>{item.FechaPago_Copago || '-'}</td>
                  </tr>
                ))}
                </tbody>
            </table>
          </div>
          </>
        )}
      </>
  )
}

export default QueryDetail